module.exports = __webpack_public_path__ + "static/media/combat(14).f52cc2c3.PNG";